import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Clientcasehome() {
  return (
    <section className="client-case-home p-100">
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2>Chosen by 500+ Brands Worldwide</h2>
            <div className="main-clutch">
              <div className="clutch-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="125"
                  height="36"
                  fill="none"
                  viewBox="0 0 125 36"
                >
                  <g clipPath="url(#clip0_8072_7890)">
                    <path
                      fill="#CCC"
                      d="M18.256 35.92c-8.92.045-15.025-4.425-17.235-11.459-1.84-5.86-1.256-11.483 2.274-16.592 2.67-3.864 6.43-6.054 11.072-6.525C20 .772 24.87 2.514 28.905 6.566c.414.416.477.674.02 1.105a51 51 0 0 0-2.761 2.792c-.452.494-.74.427-1.158-.02-1.683-1.804-3.715-3.035-6.129-3.51-5.644-1.117-10.89 1.763-12.59 7.512-1.026 3.477-.83 6.918.859 10.148 1.755 3.363 4.527 5.314 8.343 5.577 3.605.248 6.76-.813 9.31-3.458.468-.487.734-.417 1.148.026a86 86 0 0 0 2.758 2.793c.359.35.434.585.046 1.012-3.324 3.607-7.457 5.317-10.495 5.377M104.926 17.951V.99c0-.974 0-.977.955-.979 1.351 0 2.702.03 4.053-.014.675-.02.868.232.868.887-.022 3.656-.01 7.312-.01 10.967v.585c0 .367.136.429.434.204 2.026-1.543 4.366-1.787 6.753-1.384 3.542.6 5.626 2.872 6.532 6.309.307 1.154.464 2.344.466 3.54 0 4.58 0 9.161.022 13.745 0 .669-.204.911-.868.897a91 91 0 0 0-4.197 0c-.625.013-.838-.215-.835-.853.022-4.556.01-9.111.017-13.668 0-.928-.045-1.844-.289-2.748-.416-1.522-1.75-2.096-3.312-1.933-3.056.32-4.691 2.204-4.716 5.4-.032 4.29-.012 8.577-.013 12.869 0 1.123 0 1.123-1.114 1.124-1.303 0-2.605-.032-3.908.013-.682.024-.857-.237-.854-.889.025-5.707.016-11.408.016-17.11M58.205 34.093c-.488.307-.828.585-1.216.758-3.559 1.563-7.091 1.675-10.404-.57-2.68-1.815-3.832-4.572-4.013-7.74-.268-4.697-.057-9.402-.125-14.103-.01-.665.22-.898.884-.877 1.326.042 2.653.011 3.979.013 1.09 0 1.094 0 1.094 1.078v12.722a9 9 0 0 0 .097 1.608c.567 3.145 2.533 3.868 5.11 3.387 3.04-.566 4.562-2.486 4.582-5.639.026-4.044 0-8.09.009-12.137 0-1.003.01-1.01 1.013-1.012h3.833c1.097 0 1.1 0 1.1 1.15v22.152c0 1.053 0 1.054-1.046 1.056h-3.907c-.986 0-.987 0-.996-1.024a41 41 0 0 0 .006-.822M92.717 11.12c3.584-.06 6.53 1.463 9.184 3.73.276.235.338.418.037.699a214 214 0 0 0-3.263 3.104c-.434.42-.724.205-1.013-.146-1.882-2.232-5.908-2.558-8.422-1.123-1.916 1.092-2.894 2.817-3.124 4.971-.28 2.53.603 5.487 3.22 7.008 2.495 1.45 6.119 1.023 8.262-1.049.496-.48.792-.528 1.274 0 .95 1.034 1.955 2.021 2.959 3.002.394.385.365.585-.066.963-2.178 1.868-4.582 3.186-7.472 3.545-5.954.745-11.688-2.567-13.345-8.685-1.14-4.213-.557-8.19 2.239-11.636 2.448-3.018 5.712-4.349 9.53-4.382M75.339 26.674v8.042c0 1.215 0 1.215-1.238 1.215h-3.473c-1.158 0-1.158 0-1.158-1.14V18.415c0-1.107 0-1.107-1.126-1.109-.796 0-1.592-.017-2.386 0-.544.013-.793-.199-.786-.769.017-1.414.014-2.827 0-4.24 0-.518.18-.755.724-.732.891.03 1.785-.03 2.676.02.681.037.926-.172.913-.894-.042-2.29-.016-4.58-.015-6.873 0-1.024 0-1.024.981-1.024h3.908c.973 0 .978 0 .978.963 0 2.29.028 4.581-.013 6.872-.013.718.164 1.024.924.963.887-.063 1.783 0 2.674-.02.462-.01.65.167.644.641-.016 1.484-.022 2.97 0 4.454.009.491-.195.65-.64.643-.796-.008-1.591 0-2.387 0-1.202 0-1.203 0-1.203 1.18zM38.419 18.049v16.734c0 1.144 0 1.145-1.097 1.147-1.375 0-2.75-.018-4.122 0-.536.01-.759-.2-.724-.724.01-.171 0-.342 0-.512V1.225c0-1.218 0-1.218 1.172-1.22h3.763c1.013 0 1.013 0 1.013 1.01z"
                    ></path>
                    <path
                      fill="#EF4335"
                      d="M92.447 27.583a4 4 0 0 1-1.546-.323 4 4 0 0 1-1.303-.9 4.094 4.094 0 0 1-1.142-2.908c.024-2.217 1.916-4.06 4.129-4.021 2.158.038 3.998 1.946 3.972 4.12a4.11 4.11 0 0 1-1.228 2.875 4.03 4.03 0 0 1-2.882 1.157"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_8072_7890">
                      <path fill="#fff" d="M0 0h125v36H0z"></path>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="clutch-item">
                <svg
                  className="stars"
                  xmlns="http://www.w3.org/2000/svg"
                  width="138"
                  height="26"
                  fill="none"
                  viewBox="0 0 138 26"
                >
                  <path
                    fill="#C2C5C8"
                    d="m13 0 2.919 8.983h9.445l-7.642 5.551 2.92 8.983L13 17.966l-7.641 5.551 2.918-8.983-7.64-5.551h9.444zM41 0l2.919 8.983h9.445l-7.642 5.551 2.92 8.983L41 17.966l-7.641 5.551 2.919-8.983-7.642-5.551h9.445zM69 0l2.919 8.983h9.445l-7.642 5.551 2.92 8.983L69 17.966l-7.641 5.551 2.919-8.983-7.642-5.551h9.445zM97 0l2.919 8.983h9.445l-7.641 5.551 2.918 8.983L97 17.966l-7.641 5.551 2.919-8.983-7.642-5.551h9.445zM125 0l2.919 8.983h9.445l-7.641 5.551 2.918 8.983L125 17.966l-7.641 5.551 2.918-8.983-7.641-5.551h9.445z"
                  ></path>
                </svg>
              </div>
              <div className="clutch-item">
                <Link to="https://clutch.co/profile/tekrevol">4.9 Rating</Link>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="main-clients-box">
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/find-serve-logo.webp"
                    alt="find-serve-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/yeppy-logo.webp"
                    alt="yeppy-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/truth-gpt-logo.webp"
                    alt="truth-gpt-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                  <div className="case-btn-client">
                    <Link to="">Case study</Link>
                    <div className="client-popup-box">
                      <h3>TruthGPT</h3>
                      <hr />
                      <p>
                        We came to TekRevol with just an idea — an AI chatbot
                        mobile app that gives honest, clear, and reliable
                        information. They didn’t just build the app, they
                        brought it to life.
                      </p>
                      <p>
                        The result? More user trust, double the engagement, and
                        an app we’re truly proud of. TekRevol didn’t just meet
                        our expectations — they crushed them.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/schology-logo.webp"
                    alt="schology-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/kinekt-logo.webp"
                    alt="kinekt-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/amj-wellness-logo.webp"
                    alt="amj-wellness-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/animal-debt-logo.webp"
                    alt="animal-debt-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                  <div className="case-btn-client">
                    <Link to="">Case study</Link>
                    <div className="client-popup-box animal-debt-box">
                      <h3>Animal Debt Disaster</h3>
                      <hr />
                      <p>
                        They translated my vision for my game perfectly without
                        changing much and were great at applying everything we
                        wanted in our video game. The flexibility and creativity
                        these guys have is very impressive. So, I do look
                        forward to working with them again in the future.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/save-win.webp"
                    alt="save-win"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/pure-plank-logo.webp"
                    alt="pure-plank"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/soundly-logo.webp"
                    alt="soundly-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                  <div className="case-btn-client">
                    <Link to="">Case study</Link>
                    <div className="client-popup-box">
                      <h3>Soundly</h3>
                      <hr />
                      <p>
                        I’ve worked with other developers before, but the
                        quality TekRevol delivered is on another level. After
                        six months of collaboration, their communication and
                        professionalism truly stood out.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/milocare-logo.webp"
                    alt="milocare-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/rodeo-logo.webp"
                    alt="rodeo-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/mdrouz-logo.webp"
                    alt="mdrouz-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/alhussaini-logo.webp"
                    alt="alhussaini-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                  <div className="case-btn-client">
                    <Link to="">Case study</Link>
                    <div className="client-popup-box animal-debt-box">
                      <h3>Al-Hussaini</h3>
                      <hr />
                      <p>
                        By connecting our online and physical stores, TekRevol
                        made shopping easier for our customers. What really
                        stood out was how they made shopping for luxury watches
                        easier — from browsing collections to secure checkouts,
                        everything feels smooth and effortless.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/stop-vaping-logo.webp"
                    alt="stop-vaping-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/mobius-logo.webp"
                    alt="mobius-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                  <div className="case-btn-client">
                    <Link to="">Case study</Link>

                    <div className="client-popup-box">
                      <h3>Mobius Risknet</h3>
                      <hr />
                      <p>
                        Working with TekRevol helped us bring our risk
                        management system into the modern mobile world. They
                        understood our needs from day one and delivered apps
                        that mirror our ERP platform while being simple, fast,
                        and secure.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/ether-logo.webp"
                    alt="ether-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                </div>
              </div>
              <div className="client-logo-item">
                <div className="client-img">
                  <StaticImage
                    src="../../images/home-update/client-case/teemates-logo.webp"
                    alt="teemates-logo"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={120}
                  />
                  <div className="case-btn-client ">
                    <Link to="">Case study</Link>
                    <div className="client-popup-box teemates-last">
                      <h3>TeeMates</h3>
                      <hr />
                      <p>
                        TeeMates has transformed how golfers connect and share
                        experiences. TekRevol built a smooth, user-friendly app
                        that makes it easy to organize tee times, buy equipment,
                        and chat with other golfers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clientcasehome;
